import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import EditProfile from '../../assets/dashboard/account/edit-profile.svg';
import Password from '../../assets/dashboard/account/password.svg';
import Demographics from '../../assets/dashboard/account/demographics.svg';
// import Notifications from '../../assets/dashboard/account/notifications.svg';
import RightArrow from '../../assets/dashboard/account/right-arrow.svg';

class SettingsNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPage: this.props.defaultPage,
    };
  }

  handleClick = (page) => {
    this.setState({ selectedPage: page });
  }

  render() {
    return (
      <div className="account-nav-container">
        <h2>Account</h2>
        <NavLink
          to="/dashboard/account"
          onClick={() => this.handleClick('profile')}
        >
          <img className="account-nav-icon" src={EditProfile} alt="edit-profile" />
          <p
            className={this.state.selectedPage === 'color' ? 'color active-account-nav-text' : 'color'}
          >Edit Profile
          </p>
          {this.state.selectedPage === 'profile'
            ? <img className="right-arrow-img" src={RightArrow} alt="right-arrow" />
            : null}
        </NavLink>
        {/* <NavLink
          to="/dashboard/account/notifications"
          onClick={() => this.handleClick('notifications')}
        >
          <img className="account-nav-icon" src={Notifications} alt="notifications" />
          <p
            className={this.state.selectedPage === 'notifications' ? 'color active-account-nav-text' : 'color'}
          >Notifications
          </p>
          {this.state.selectedPage === 'notifications'
            ? <img className="right-arrow-img" src={RightArrow} alt="right-arrow" />
            : null}
        </NavLink> */}
        <NavLink
          to="/dashboard/account/password"
          onClick={() => this.handleClick('password')}
        >
          <img className="account-nav-icon" src={Password} alt="password" />
          <p
            className={this.state.selectedPage === 'password' ? 'color active-account-nav-text' : 'color'}
          >Password
          </p>
          {this.state.selectedPage === 'password'
            ? <img className="right-arrow-img" src={RightArrow} alt="right-arrow" />
            : null}
        </NavLink>
        <NavLink
          to="/dashboard/account/demographics"
          onClick={() => this.handleClick('demographics')}
        >
          <img className="account-nav-icon" src={Demographics} alt="demographics" />
          <p
            className={this.state.selectedPage === 'demographics' ? 'color active-account-nav-text' : 'color'}
          >Demographics
          </p>
          {this.state.selectedPage === 'demographics'
            ? <img className="right-arrow-img" src={RightArrow} alt="right-arrow" />
            : null}
        </NavLink>
      </div>
    );
  }
}

export default SettingsNavBar;
